// extracted by mini-css-extract-plugin
module.exports = {"form":"AccreditationForm_form__2KiU3","submitBtn":"AccreditationForm_submitBtn__2qUpp","link":"AccreditationForm_link__1Nox7"};